export const PLACEHOLDER_BASE = "https://placehold.co/240x180/10b981/ffffff?text=";

export const GOOGLE_SHEET_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSLKA6Q1lcHhpkw-ZtiI364wtyAtrLJ6SZoUgGFuiRE0YTQEHYRiersA0S2LceGlUEgTeFCuRxPDbKx/pub?output=tsv";
